import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { DOWNLOAD_LINK, LOGO_URL } from "@/lib/constants";

const NAV_ITEMS = [
  { label: "Features", href: "#features" },
  { label: "How it works", href: "#how-it-works" },
  { label: "Rates", href: "#rates" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 sm:h-20 items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 group" data-testid="nav-logo">
            <img src={LOGO_URL} alt="PamaPay" className="h-9 w-9 rounded-lg" />
            <span className="font-display font-black tracking-tight text-lg sm:text-xl text-slate-900">
              PamaPay
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={DOWNLOAD_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 bg-[#3B6FBF] hover:bg-[#2f5ca3] text-white text-sm font-semibold rounded-full px-5 py-2.5 transition-all"
              data-testid="nav-download-btn"
            >
              Download App <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <button
            className="md:hidden p-2 text-slate-900"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-6 pt-2 border-t border-slate-200 bg-white" data-testid="mobile-menu">
            <div className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="py-3 text-base text-slate-700 hover:text-slate-900"
                  data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {item.label}
                </a>
              ))}
              <a
                href={DOWNLOAD_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 inline-flex items-center justify-center gap-1.5 bg-[#3B6FBF] hover:bg-[#2f5ca3] text-white font-semibold rounded-full px-5 py-3"
                data-testid="mobile-download-btn"
              >
                Download App <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
